module.exports = __webpack_public_path__ + "static/media/slide4.741ccf87.gif";